// @ts-nocheck
import { gql } from "@apollo/client";
import { SpogInstall } from "../types/SpogInstall";
import { HgProductCategory } from "../../types/taxonomy";

export const COMPANY_INSTALLS_PRESENCE = gql`
  query installsPresence($hgId: Identifier!) {
    install(hgId: $hgId, per: 1) {
      data {
        product {
          id
        }
      }
      count
    }
  }
`;

export const COMPANY_INSTALLS_LOCATIONS_QUERY = gql`
  query install(
    $hgId: Identifier!
    $countryAlpha2s: [String]!
    $per: Int!
    $regionName: String
    $productIds: [Int]
  ) {
    install(
      hgId: $hgId
      countryAlpha2s: $countryAlpha2s
      regionName: $regionName
      productIds: $productIds
      per: $per
      sort: [{ field: "locations", direction: DESC }]
    ) {
      data {
        locations
        location {
          city
          state {
            id
            name
            country {
              alpha2
              name
            }
          }
        }
      }
    }
  }
`;

export const COMPANY_INSTALLS_TABLE_QUERY = gql`
  query productInstalls(
    $hgId: Identifier!
    $includeCorporateDescendants: Boolean
    $page: Int!
    $per: Int!
    $sort: [Sort]!
    $countryAlpha2s: [String]
    $productIds: [Int]
    $vendorIds: [Int]
    $productCategoryIds: [Identifier]
    $productAttributeIds: [Int]
    $fuzzySearch: String
  ) {
    install(
      hgId: $hgId
      includeCorporateDescendants: $includeCorporateDescendants
      page: $page
      per: $per
      sort: $sort
      countryAlpha2s: $countryAlpha2s
      productIds: $productIds
      vendorIds: $vendorIds
      categoryIds: $productCategoryIds
      productAttributeIds: $productAttributeIds
      fuzzySearch: $fuzzySearch
    ) {
      data {
        product {
          id
          name
          description
          attributeNames
          vendor {
            id
            name
            url
          }
          category {
            id
            name
            nameTree
          }
        }
        firstVerified
        lastVerified
        intensity
        locations
        url
        hgIdAny
      }
      count
    }
  }
`;

export const COMPANY_INSTALL_LOCATIONS_BY_PRODUCT_ID_QUERY = gql`
  query install(
    $hgId: Identifier!
    $productIds: [Int]!
    $countryAlpha2s: [String]
  ) {
    install(
      hgId: $hgId
      productIds: $productIds
      countryAlpha2s: $countryAlpha2s
      page: 0
      per: 10000
      sort: [{ field: "locations", direction: DESC }]
    ) {
      data {
        locations
        location {
          state {
            country {
              alpha2
              name
            }
          }
        }
      }
      count
    }
  }
`;

export const COMPANY_INSTALL_LOCATIONS_BY_PRODUCTS_AND_COUNTRY_QUERY = gql`
  query installsByCountry(
    $hgId: Identifier!
    $countryAlpha2s: [String]
    $productIds: [Int]
    $vendorIds: [Int]
    $productCategoryIds: [Identifier]
    $productAttributeIds: [Int]
  ) {
    install(
      hgId: $hgId
      per: 300 # Magic number to guarantee we get all countries in 1 page
      sort: [{ field: "products", direction: DESC }]
      countryAlpha2s: $countryAlpha2s
      productIds: $productIds
      vendorIds: $vendorIds
      categoryIds: $productCategoryIds
      productAttributeIds: $productAttributeIds
    ) {
      data {
        products
        locations
        location {
          state {
            country {
              alpha2
              name
            }
          }
        }
      }
      count
    }
  }
`;

export const COMPANY_INSTALL_VENDORS_BY_CATEGORY_QUERY = gql`
  query install(
    $hgId: Identifier!
    $isRolledUp: Boolean
    $countryAlpha2s: [String]
    $productIds: [Int]
    $vendorIds: [Int]
    $productCategoryIds: [Identifier]
    $page: Int!
    $per: Int!
    $sort: [Sort]
  ) {
    installVendorCountByCategory(
      hgId: $hgId
      countryAlpha2s: $countryAlpha2s
      productIds: $productIds
      vendorIds: $vendorIds
      categoryIds: $productCategoryIds
      isRolledUp: $isRolledUp
      page: $page
      per: $per
      sort: $sort
    ) {
      data {
        hgId
        category {
          id
          name
          nameTree
        }
        vendorCount
      }
      count
    }
  }
`;

export const COMPANY_INSTALL_TOP_VENDORS_BY_PRODUCTS_QUERY = gql`
  query topVendorsByProductCount(
    $hgId: Identifier!
    $vendorIds: [Int]
    $productIds: [Int]
    $countryAlpha2s: [String]
    $productCategoryIds: [Identifier]
  ) {
    topVendorsByProductCount(
      hgId: $hgId
      filters: {
        productIds: $productIds
        vendorIds: $vendorIds
        categoryIds: $productCategoryIds
        countryAlpha2s: $countryAlpha2s
      }
    ) {
      vendorId
      vendorName
      productCount
    }
  }
`;
export interface TopVendorsByProductCount {
  productCount: number;
  vendorId: number;
  vendorName: string;
}

export interface TopVendorsByProductsCountPayload {
  topVendorsByProductCount: TopVendorsByProductCount[];
}

export default interface FAIByLocationData {
  city?: string;
  state: string;
  country: string;
  firstVerified: Date;
  lastVerified: Date;
  signalStrength: string;
  decisionMaker: boolean;
  influencer: boolean;
  decisionMakerTitles: string[];
  influencerTitles: string[];
  totalLocationCount: number;
}

export interface CompanyInstallsPayload {
  install: {
    data: SpogInstall[];
    count: number;
  };
}

export interface InstallVendorsByCategory {
  hgId: string;
  category: HgProductCategory;
  vendorCount: number;
}

export interface CompanyInstallsVendorsByCategoryPayload {
  installVendorCountByCategory: {
    data: InstallVendorsByCategory[];
    count: number;
  };
}
